// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"ca4ace14","144":"47aec1f2","243":"438b48c7","357":"e90dffc0","364":"2de6403c","553":"99f1d24f","662":"42758f3a","900":"cad5a1e7","992":"3f93f051"}[chunkId] + ".chunk.js";
};